<div class="search-form">
  <input
    type="text"
    placeholder="I am searching for"
    autocomplete="off"
    #searchInput
    [(ngModel)]="searchText"
  />
  @if (searchText) {
    <button class="btn-close" (click)="clearSearch()">
      <i class="fal fa-times"></i>
    </button>
  }
  <button
    class="search-button"
    type="button"
    name="button"
    [ngClass]="{ searching: isSearching }"
    (click)="search()"
  >
    <i class="far fa-search"></i>
  </button>
</div>

@if (isSearching) {
  <div class="searching">
    Searching<span class="searching__dot">.</span
    ><span class="searching__dot">.</span><span class="searching__dot">.</span>
  </div>
}

@if (searchPerformed) {
  <div class="search__autocomplete gold-border">
    @if (foundProductsCount > 0) {
      <ul class="search__result-list">
        @for (product of foundProducts; track product) {
          <li>
            <a (click)="selectSearchOption(product)">
              <span [innerHTML]="showHighlights(product.label)"></span>
            </a>
          </li>
        }
      </ul>
      @if (isMoreDataAvailable) {
        <div class="search__result-list__view-all">
          <a title="View All Results" (click)="selectViewAll()"
            ><span>View All Results</span></a
          >
        </div>
      }
      <div class="search__result-list__view-all mt-3">
        <a title="Close" (click)="clearSearch()"
          ><span>Clear Search Results</span></a
        >
      </div>
    } @else {
      <div>
        <h4>No Results</h4>
      </div>
    }
  </div>
}
